// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2emmw","largestCol":"styles_largestCol__2e13d","smallestCol":"styles_smallestCol__3aBW-"};